import { useMemo } from 'react';

import type { SelectOption } from '@swf/components/Inputs/components/DropDown/DropDown';
import { Currency } from '@swf/core/enums';
import type { TableParams } from '@swf/generated/types/api/v0/SwHomeGames';

import { fallback } from '../utils/common';

const useGetCurrency = (
  gameData: TableParams[],
  handTypeValue: string,
  gameType: TableParams['potStruct'],
  tableSize: TableParams['tableSize']
): SelectOption[] =>
  useMemo(() => {
    if (!gameData || !gameData.length) return fallback;

    const { handType, hiLo } = JSON.parse(handTypeValue);
    const data = gameData.filter(
      (item) =>
        item.handType === handType &&
        item.hiLo === hiLo &&
        item.potStruct === gameType &&
        item.tableSize === tableSize
    );

    const options = [...new Set(data.map(({ currency }) => currency))].map((currency) => ({
      // Server response for Play money is an empty string, otherwise - USD, EUR etc.
      text: currency || 'Play Money',
      // React final form won't accept an option with the value of ''
      value: currency || Currency.PlayMoney
    }));

    if (!options || !options.length) return fallback;

    return options;
  }, [gameData, handTypeValue, gameType, tableSize]);

export default useGetCurrency;
